/* app/js/src/components/common/time-editor/time-editor.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.container {
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  outline: none;
  padding: 4px;
  width: inherit;
}
.container:focus {
  border: 1px solid #aee5ff !important;
  outline: none;
  transition: all 0.9s ease 0s !important;
}
/*# sourceMappingURL=time-editor.component.css.map */
